import styled from 'styled-components';
import { Button as btn } from '@mui/material';

export const Header = styled.h2`
  display: block;
  margin-bottom: 20px;
  padding: 10px;  
  background-color: #707070;
  color: #f3f3f1;
  width: 100%;
  font-size: 20px;  
  text-align: center;
  border-radius: 0px 0px 5px 5px;
`;

export const BoxButtons = styled.div`
  display: block;
  text-align: start;
  padding: 5px;
  border-radius: 10;
  color: #fff;
  font-size: 15px;
  margin-left: 300;
  margin-bottom: 10px;
  /* border: 1px solid blue; */
`;

export const Button = styled(btn)`
  text-align: end;
  padding: 5px;
  border-radius: 10;
  color: #fff;
  font-size: 15px;
  margin-left: 10px !important;
`;
